import { Link } from "@zestia/gatsby-plugin-react-i18next"
import React from "react"
import { gtmTracking } from "@/utils/gtm-tracking"

const FeatureOverviewTile = ({
  title,
  hasPage,
  pricingLevel,
  externalUrl,
  children,
  linkLanguage,
}) => {
  return (
    <li className={`features-overview__feature`}>
      <h6 className="features-overview__feature-title">
        {hasPage || externalUrl ? (
          externalUrl ? (
            <a
              href={externalUrl}
              className="text-link"
              onClick={() => gtmTracking("Link Click", title, "Feature Tile")()}
            >
              {title}
            </a>
          ) : (
            <Link
              to={hasPage}
              className="text-link"
              language={linkLanguage}
              onClick={() => gtmTracking("Link Click", title, "Feature Tile")()}
            >
              {title}
            </Link>
          )
        ) : (
          title
        )}
        {pricingLevel && <span className="ml-2 tag">{pricingLevel}</span>}
      </h6>
      <p className="features-overview__feature-summary">{children}</p>
    </li>
  )
}

export default FeatureOverviewTile
